module.exports = __webpack_public_path__ + "img/melb_uni_IT.6a7df485.jpeg";